import Radium from "radium";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { semanticColors } from "../../../Globals/styles";
import EmployeeWeekOverview from "../../EmployeeWeekOverview";
import { showSidebarConst } from "../../../Globals/constants";
import EmployeeListView from "../EmployeeListView";

class Sidebar extends Component {
  render() {
    const { toggleSidebar, showSidebar, params } = this.props;
    return (
      <div
        style={[
          styles.outerContainer,
          (showSidebar === showSidebarConst.EMP_LIST && styles.isEmpList) ||
            styles.week,
        ]}
      >
        <div
          style={
            showSidebar === showSidebarConst.EMP_LIST
              ? styles.sideBarContainer
              : styles.sideBarContainerWeek
          }
        >
          {showSidebar === showSidebarConst.EMP_LIST ? (
            <EmployeeListView
              toggleSidebar={() => toggleSidebar(showSidebarConst.NOT_SHOWING)}
              params={params}
            />
          ) : (
            <EmployeeWeekOverview
              toggleSidebar={() => toggleSidebar(showSidebarConst.NOT_SHOWING)}
              departmentId={params.departmentId}
            />
          )}
        </div>
      </div>
    );
  }
}
var styles = {
  outerContainer: {
    position: "absolute",
    top: "0",
    right: "0",
    height: "100%",
    paddingTop: "51px",
    width: "100%",
  },
  isEmpList: {
    width: "25%",
    "@media (min-width: 320px) and (max-width: 480px)": {
      width: "55%",
    },
  },
  week: {
    "@media (min-width: 320px) and (max-width: 480px)": {
      width: "100%",
    },
  },
  sideBarContainer: {
    position: "relative",
    boxShadow: "-3px 5px 16px -2px rgba(0,0,0,0.54)",
    width: "100%",
    height: "100%",
    backgroundColor: semanticColors.default,
    borderRadius: "2px 0 0 2px",
    zIndex: "11",
    "@media (min-width: 320px) and (max-width: 480px)": {
      position: "fixed",
      width: "55%",
      height: "45%",
    },
  },
  sideBarContainerWeek: {
    position: "relative",
    boxShadow: "-3px 5px 16px -2px rgba(0,0,0,0.54)",
    width: "100%",
    height: "100%",
    backgroundColor: semanticColors.default,
    borderRadius: "2px 0 0 2px",
    zIndex: "11",
    "@media (min-width: 320px) and (max-width: 480px)": {
      position: "fixed",
      width: "100%",
      height: "100%",
    },
  },
};
Sidebar.propTypes = {
  toggleSidebar: PropTypes.func.isRequired,
  showSidebar: PropTypes.oneOf(Object.keys(showSidebarConst)),
  params: PropTypes.shape({
    departmentId: PropTypes.string.isRequired,
  }).isRequired,
};
export default Radium(Sidebar);



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Kanban/Sidebar/index.jsx